import { render, staticRenderFns } from "./SignupComponent.vue?vue&type=template&id=8a01bfd0&scoped=true&"
import script from "./SignupComponent.vue?vue&type=script&lang=js&"
export * from "./SignupComponent.vue?vue&type=script&lang=js&"
import style0 from "./SignupComponent.vue?vue&type=style&index=0&id=8a01bfd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a01bfd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCardText,VCheckbox,VForm})
